// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 8px;
  .cta-button-text {
    display: inline;
    padding: 8px;
    text-decoration: underline;
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-size: 14px;
    font-weight: bold;
    &:hover {
      background-color: unset !important;
    }
  }
`;

export default Container;
